var map = {
	"./Checkbox/index.vue": "/Efy",
	"./Completion/index.vue": "S2Bd",
	"./Radio/index.vue": "uZZB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gKxS";


//////////////////
// WEBPACK FOOTER
// ./src/components/Data/TaskResult \/index\.vue$
// module id = gKxS
// module chunks = 1